import { AddUserIcon, SignInIcon } from '@efacity/react-next-sc';
import { PATHS } from '@efacity/routing';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import { authLinkButtonSx } from '../authButtonsStyles';

export default function SignInButtons() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        endIcon={matches && <AddUserIcon />}
        style={{ marginRight: 10 }}
        sx={authLinkButtonSx}
        href={`/auth/${PATHS.signUp}`}
      >
        Sign up
      </Button>
      <Button
        variant="contained"
        color="secondary"
        endIcon={matches && <SignInIcon />}
        sx={authLinkButtonSx}
        href={`${PATHS.auth}/${PATHS.signIn}`}
      >
        Log in
      </Button>
    </>
  );
}
